import { render, staticRenderFns } from "./SaleProductsModal.vue?vue&type=template&id=387f62c1&scoped=true"
import script from "./SaleProductsModal.vue?vue&type=script&lang=js"
export * from "./SaleProductsModal.vue?vue&type=script&lang=js"
import style0 from "./SaleProductsModal.vue?vue&type=style&index=0&id=387f62c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f62c1",
  null
  
)

export default component.exports